import Cookies from "js-cookie";

export const setUserId = (token) => {
  Cookies.set("user_id", token);
};

export const getUserId = () => {
  return Cookies.get("user_id");
};

export const removeUserId = () => {
  Cookies.remove("user_id");
};